import { render } from "./SubmitScenarioResource.vue?vue&type=template&id=69d201b3&scoped=true"
import script from "./SubmitScenarioResource.vue?vue&type=script&lang=js"
export * from "./SubmitScenarioResource.vue?vue&type=script&lang=js"

import "./SubmitScenarioResource.vue?vue&type=style&index=0&id=69d201b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69d201b3"

export default script